const baseURL = "https://cadevapicdn02.freeli.io";
const wsbaseURL = "wss://cadevapicdn02.freeli.io";

// const baseURL = "http://localhost:4001";
// const wsbaseURL = "ws://localhost:4001";

const xmpp_domain = "caquecdn02.freeli.io";
const FILE_SERVER = "https://wfss001.freeli.io";
const return_data = {
        "FILE_SERVER": "https://wfss001.freelio.io",
        "baseURL": baseURL,
        "xmpp_domain": xmpp_domain
}
export {return_data, FILE_SERVER, baseURL, wsbaseURL};
